import React, { Fragment, useState } from "react";
import Topbar from "../layouts/TopBar";
import AbsenceResources from "../resources/AbsenceResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'

function RequestAbsences({isLoggedIn, loggedInUser}){
  const [absenceReason, setAbsenceReason] = useState('');
  const [hasPickedRange, setHasPickedRange] = useState(false);
  const [dateSelectionRange, setDateSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const today = new Date();
  const absenceResources = new AbsenceResources()

      const handleDateSelectRange = (ranges) => {
        setDateSelectionRange(ranges.selection);
        setHasPickedRange(true);
      };

      const handleAbsenceReasonChange = (event) => {
          setAbsenceReason(event.target.value);
      };

      const handleAddAbsenceButtonClick = () => {

        if(!loggedInUser || !loggedInUser.id)
        {
          toast.error("User not logged in")
          return;
        }

        if(Object.keys(absenceReason).length === 0)
            {
              toast.error("Please Enter a Reason")
              return;
            }

        if(!hasPickedRange)
            {
              toast.error("Please Select the date range of your absence")
              return;
            }

        let absence = {};
        absence['user_id'] = loggedInUser.id
        absence['reason'] = absenceReason
        absence['date_added'] = moment( new Date()).format('YYYY-MM-DD HH:mm:ss')
        absence['start_date'] = moment( dateSelectionRange['startDate']).format('YYYY-MM-DD HH:mm:ss')
        absence['end_date'] = moment( dateSelectionRange['endDate']).format('YYYY-MM-DD HH:mm:ss')
        absenceResources.post(absence).then(res => {
            if (res.error.length < 1) {
                toast.success("Absence Added Successfully")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/absences';
                  }, 1000);
            }
            else if(res.error === 'Unconfirmed User') {
                toast.error("You can only add absences for yourself.")
            }
            else if(res.error.length > 1) {
                toast.error(res.error)
            }
                else {
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });
      };

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                        {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Request Absence</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }

                        </div>
                    </div>
                </div>
            </div>

            <div id="main-container">
                {
                    isLoggedIn ?

                <div className="content">
                    <div className="container">
                        <div className="spacer-40"></div>

                        <div style={{
                            maxWidth: '800px',
                            margin: '0 auto',
                            padding: '30px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '10px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                        }}>
                            <h3 style={{color: "#003165", marginBottom: '10px'}}>
                                <strong>Request Your Absence</strong>
                            </h3>
                            <p style={{color: "#666", marginBottom: '30px'}}>
                                Please submit your absence request as early as possible
                            </p>

                            {loggedInUser && (
                                <div style={{
                                    backgroundColor: '#fff',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    marginBottom: '25px',
                                    border: '2px solid #ffa800'
                                }}>
                                    <p style={{margin: 0, color: '#003165'}}>
                                        <strong>Requesting for:</strong> {loggedInUser.firstname} {loggedInUser.lastname}
                                    </p>
                                </div>
                            )}

                            <div style={{marginBottom: '25px'}}>
                                <label style={{
                                    display: 'block',
                                    color: '#003165',
                                    fontWeight: 'bold',
                                    marginBottom: '10px'
                                }}>
                                    Absence Period <span style={{color: '#dc3545'}}>*</span>
                                </label>
                                <DateRangePicker
                                    editableDateInputs
                                    onChange={handleDateSelectRange}
                                    moveRangeOnFirstSelection={false}
                                    ranges={[dateSelectionRange]}
                                    minDate={today}
                                />
                            </div>

                            <div style={{marginBottom: '25px'}}>
                                <label style={{
                                    display: 'block',
                                    color: '#003165',
                                    fontWeight: 'bold',
                                    marginBottom: '10px'
                                }}>
                                    Reason <span style={{color: '#dc3545'}}>*</span>
                                </label>
                                <textarea
                                    value={absenceReason}
                                    onChange={handleAbsenceReasonChange}
                                    placeholder="Please provide a reason for your absence..."
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '6px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px',
                                        fontFamily: 'inherit',
                                        minHeight: '100px',
                                        resize: 'vertical'
                                    }}
                                />
                            </div>

                            <button
                                onClick={handleAddAbsenceButtonClick}
                                style={{
                                    backgroundColor: '#ffa800',
                                    color: '#fff',
                                    padding: '12px 30px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    width: '100%',
                                    transition: 'background-color 0.3s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#003165'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#ffa800'}
                            >
                                Submit Absence Request
                            </button>
                        </div>
                    </div>
                </div> : <></>
        }
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };

};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestAbsences);
